import { Button, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { ISelectAllergens } from '../../interface/interface';

interface Props { 
    index: number;
    selectAllergen: string;
    selectAllergens: ISelectAllergens[];
    selected: boolean;
    setSelectAllergens: React.Dispatch<React.SetStateAction<any>>;
}

const useStyles = makeStyles((theme: any) => ({
    container: {
        background: '#F3F3F9',
        borderRadius: '13px',
        fontSize: '10px',
        fontWeight: 400,
        padding: 7,
        cursor: 'pointer',
        marginLeft: 7,
        marginBottom: 7,
        color: "#374251",

        "&:hover":{
            opacity: 0.7
        }
    }, 
    selected: {
        background: "#6178ED",
        color: "#F3F3F9",

        "&:hover":{
            background: "#6178ED",
            opacity: 0.7
        }
    }
}));

export const AllergenButton: React.FC<Props> = ({index,selectAllergen,selectAllergens,selected,setSelectAllergens}) => {
    // Styling
    const classes = useStyles();
    
    const updateAllergens = () => {
        const newAllergens: ISelectAllergens[] = [];
        selected = !selected;

        selectAllergens.forEach( (selectAllergensItem) => {
            if(selectAllergensItem.allergen=== selectAllergen){
                selectAllergensItem.selected = selected;
            } 
            newAllergens.push(selectAllergensItem)
        });
        setSelectAllergens(newAllergens);
    }

    return (
        <Button className={clsx(classes.container,selected && classes.selected)} onClick={() => updateAllergens()}>
            {index}. {selectAllergen}
        </Button>
    );
}